import {type Crop, type Hotspot} from './types'

export const DEFAULT_HOTSPOT: Hotspot = {
  x: 0.5,
  y: 0.5,
  height: 1,
  width: 1,
}

export const DEFAULT_CROP: Crop = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
}
